import { js_utils } from "../utils/frfr-js-utils";
import { _virbom_bidirectional_traversing_update } from "../utils/frfr-virbom-bidirectional-traversing-utils";

// SIMULACIJA RADNIH NALOGA

/*
PROBLEMATIKA:

kolicina
kolicina za nalog

KORAK OWN treba da dobija i podatke od parenta
...

*/



export const _dopuni_virbom_seq_sa_simuliranim_radnim_nalozima = (virbom_seq) => {
  console.log('***** SIMULACIJA RADNIH NALOGA RACUNANJE i update virbom_seq sa');

  const _own_data_creator = (virtel, parent_data) => {
    const own_data = {
      kolicina: 0,
      kolicina_za_nalog: 0
    };
    if (js_utils.is_number(virtel.kolicina) && virtel.kolicina > 0) {
      own_data.kolicina = virtel.kolicina;
    }
    if (parent_data && js_utils.is_number(parent_data.kolicina_za_nalog)) {
      // ima prent kolicina_za_nalog
      own_data.kolicina_za_nalog = parent_data.kolicina_za_nalog * own_data.kolicina;
    } else {
      // nema parent
      own_data.kolicina_za_nalog = own_data.kolicina;
    }
    // console.log(own_data);
    return own_data;
  };


  const _make_new_obj_children_collected_data = () => {
    const children_collected_data = {
      // nista
    };
    return children_collected_data;
  };


  const _collector = (child_data, ref_children_collected_data) => {
    // nista
    return ref_children_collected_data;
  };


  const _combine_own_and_children_collected_data = (own_data, children_collected_data) => {
    // console.log('* children_collected_data');
    // console.log(children_collected_data);
    const combined_data = {
      kolicina_za_nalog: own_data.kolicina_za_nalog
    };
    // console.log(combined_data);
    return combined_data;
  };


  const _virtel_updater = (virtel, combined_data) => {
    const updated_virtel = { ...virtel };
    updated_virtel.kolicina_za_nalog = combined_data.kolicina_za_nalog;
    // console.log(updated_virtel);
    return updated_virtel;
  };


  // EXECUTE
  return _virbom_bidirectional_traversing_update(virbom_seq, _own_data_creator, _make_new_obj_children_collected_data, _collector, _combine_own_and_children_collected_data, _virtel_updater);
};

